module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Please select minecraft version"
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.version),
      callback: function($$v) {
        _vm.version = $$v
      },
      expression: "version"
    }
  }, _vm._l((_vm.filterVersions), function(version) {
    return _c('el-option', {
      key: 'version',
      attrs: {
        "label": version.id,
        "value": version.id
      }
    }, [_c('span', [_vm._v(_vm._s(version.id))]), _vm._v(" "), _c('span', {
      staticClass: "optionSubTitle"
    }, [_vm._v(_vm._s(version.type))])])
  })), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.showSnapshot),
      callback: function($$v) {
        _vm.showSnapshot = $$v
      },
      expression: "showSnapshot"
    }
  }, [_vm._v("Snapshot")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.showOldVersion),
      callback: function($$v) {
        _vm.showOldVersion = $$v
      },
      expression: "showOldVersion"
    }
  }, [_vm._v("Old Version")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('loadingVersion', true)
      }
    }
  }, [_vm._v("Refresh")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-52373f1e"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/VersionSelect.vue
// module id = 166
// module chunks = 1